// extracted by mini-css-extract-plugin
module.exports = {"cardContent":"ob","checkbox":"oc","labelText":"od","warningMessage":"oe","optText":"of"};